/**
 * Presentation for the rich editor inside the View/Edit pages, applied to a wrapper element. The
 * pages declare these rules themselves (the removed legacy View/Edit pages used to provide them
 * through `::ng-deep` in their own stylesheets) (Tailwind
 * arbitrary variants, no extra stylesheet): zoom-aware font size, fluid tables, a narrower left
 * gutter on desktop, and readable colours in dark mode.
 */
export const EDITOR_SURFACE_CLASSES =
  '[&_.ProseMirror]:[font-size:calc(12px*var(--fontScaleRatio,1)*var(--editorDeviceScale,1))] ' +
  'md:[&_.tiptap]:!pl-3 [&_.ProseMirror]:leading-[1.35] [&_.ProseMirror]:max-w-full [&_.ProseMirror]:overflow-x-auto ' +
  '[&_.tableWrapper]:block [&_.tableWrapper]:w-full [&_.tableWrapper]:overflow-x-auto ' +
  'dark:[&_app-rich-editor]:!bg-[#111827] dark:[&_.tiptap]:!bg-[#111827] dark:[&_.ProseMirror]:!bg-[#111827] ' +
  'dark:[&_.tiptap]:!text-[#e2e8f0] dark:[&_.ProseMirror]:!text-[#e2e8f0]';

/** Text colour for the footer save/sync indicator, keyed by the autosave view's `colorClass`. */
export function saveStatusTextClass(colorClass: string): string {
  switch (colorClass) {
    case 'autosave-status--unsaved':
      return 'text-orange-500';
    case 'autosave-status--saving':
    case 'autosave-status--syncing':
      return 'text-blue-500';
    case 'autosave-status--queued':
      return 'text-slate-500';
    case 'autosave-status--failed':
      return 'text-red-600 font-semibold';
    case 'autosave-status--offline':
      return 'text-amber-600 font-semibold';
    case 'autosave-status--saved':
      return 'text-green-500';
    default:
      return 'text-slate-400';
  }
}
